import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    paddingBottom: 30,
  },
  headerContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: 16.6,
    marginTop: 32.4,
    marginBottom: 24.4,
  },
  headerTextStyle: {
    ...Fonts.type.bold,
    fontSize: 25,
  },
});
